import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { SharedHttp } from '../../../services/http-client.service';
let AdditionalTransactionInfoModalComponent = class AdditionalTransactionInfoModalComponent {
    constructor(sanitizer, themeService, httpClient) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.ownAddress = false;
        this.firstName = '';
        this.lastName = '';
        this.addressLine = '';
        this.lastNameError = false;
        this.firstNameError = false;
        this.addressLineError = false;
        this.countryError = false;
        this.cityError = false;
        this.postCodeError = false;
        this.addressLineChecked = false;
        this.sendButtonClicked = false;
        this.errorMessage = false;
        this.step = 1;
        this.country = '';
        this.city = '';
        this.postCode = '';
        this.countriesExpanded = false;
        this.countriesDropdownInFocus = false;
        this.keyword = 'name';
        this.isCompany = false;
        this.companyName = '';
        this.companyNameError = false;
        this.companyRegistrationNumber = '';
        this.companyRegistrationNumberError = false;
        this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
        this.accentColor = this.themeService.getStyleAttribute('accent_color');
        this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        this.errorColor = this.themeService.getStyleAttribute('error_color');
    }
    ngOnInit() {
        this.getCountries();
    }
    close() {
        if (this.step === 2) {
            this.success({ dataUpdated: true });
        }
        else {
            this.success({ dataUpdated: false });
        }
        this.modal.destroy();
    }
    getCountries() {
        this.httpClient.get('user/registrationcountries').subscribe((data) => {
            this.countries = data;
        });
    }
    onFocusedCountriesDropdown(e) {
        this.countriesDropdownInFocus = e;
        this.countryError = !e && !this.country;
        return !this.countryError;
    }
    onCountriesDropdownClear(e) {
        this.country = null;
    }
    setCountry(item) {
        this.country = item.id;
    }
    checkFirstName() {
        const regex = /^[\p{L}]+(?:[-\s][\p{L}]+)*$/u;
        this.firstNameError = !this.firstName || !regex.test(this.firstName);
        return !this.firstNameError;
    }
    checkLastName() {
        const regex = /^[\p{L}]+(?:[-\s][\p{L}]+)*$/u;
        this.lastNameError = !this.lastName || !regex.test(this.lastName);
        return !this.lastNameError;
    }
    checkAddress() {
        const regex = /^(?=.*\p{L})[\p{L}0-9\s,.\-\/'’]+$/u;
        this.addressLineError = !this.addressLine || !regex.test(this.addressLine);
        this.addressLineChecked = true;
        return !this.addressLineError;
    }
    checkCity() {
        this.cityError = !this.city;
        return !this.cityError;
    }
    checkPostCode() {
        this.postCodeError = !this.postCode;
        return !this.postCodeError;
    }
    checkIfFormIsInvalid() {
        const baseInvalid = !this.addressLine || this.addressLineError ||
            !this.addressLineChecked ||
            !this.country || this.countryError ||
            !this.city || this.cityError ||
            !this.postCode || this.postCodeError;
        if (this.isCompany) {
            const companyInvalid = !this.companyName || this.companyNameError ||
                !this.companyRegistrationNumber || this.companyRegistrationNumberError;
            return !this.ownAddress && (companyInvalid || baseInvalid);
        }
        else {
            const personInvalid = !this.firstName || this.firstNameError ||
                !this.lastName || this.lastNameError;
            return !this.ownAddress && (personInvalid || baseInvalid);
        }
    }
    updateTransaction() {
        if (!this.ownAddress) {
            if (this.isCompany) {
                if (!this.checkCompanyName() || !this.checkCompanyRegistrationNumber() || !this.checkAddress() || !this.onFocusedCountriesDropdown(false) || !this.checkCity() || !this.checkPostCode()) {
                    return;
                }
            }
            else {
                if (!this.checkFirstName() || !this.checkLastName() || !this.checkAddress() || !this.onFocusedCountriesDropdown(false) || !this.checkCity() || !this.checkPostCode()) {
                    return;
                }
            }
        }
        this.sendButtonClicked = true;
        const addressData = {
            txId: this.data.txData.transaction.id,
            isCompany: this.isCompany,
        };
        if (this.ownAddress) {
            addressData['ownAddress'] = this.ownAddress;
        }
        else {
            if (this.isCompany) {
                addressData['companyName'] = this.companyName;
                addressData['companyRegistrationNumber'] = this.companyRegistrationNumber;
            }
            else {
                addressData['firstName'] = this.firstName;
                addressData['lastName'] = this.lastName;
            }
            addressData['addressLine'] = this.addressLine;
            addressData['countryId'] = this.country;
            addressData['city'] = this.city;
            addressData['postCode'] = this.postCode;
        }
        this.httpClient.post('wallet/updateinfofordeposittransaction', addressData).subscribe((data) => {
            this.sendButtonClicked = false;
            this.step = 2;
        }, (error) => {
            this.sendButtonClicked = false;
            if (error.error['message']) {
                this.errorMessage = error.error['message'];
            }
        });
    }
    checkCompanyName() {
        this.companyNameError = !this.companyName;
        return !this.companyNameError;
    }
    checkCompanyRegistrationNumber() {
        this.companyRegistrationNumberError = !this.companyRegistrationNumber;
        return !this.companyRegistrationNumberError;
    }
    setIsCompany(value) {
        if (this.ownAddress) {
            return;
        }
        this.isCompany = value;
    }
};
AdditionalTransactionInfoModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp }
];
AdditionalTransactionInfoModalComponent = __decorate([
    Component({
        selector: 'ecd-additional-transaction-info-modal',
        template: __importDefault(require("./additional-transaction-info-modal.component.html")).default
    })
], AdditionalTransactionInfoModalComponent);
export { AdditionalTransactionInfoModalComponent };
